"use strict";
// ENUM
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Command_1 = __importDefault(require("./Command"));
const logger_1 = require("../utils/logger");
class CommandsManager {
    constructor() {
        this.connectedPeers = [];
        this.commands = {};
        this.connectedPeers = [];
        this.logger = new logger_1.Logger('CommandsManager', false);
    }
    // methods
    getCommandById(id) {
        if (this.commands[id] === undefined) {
            this.logger.warn("Couldn't find command with id", id, 'in', this.commands);
            return undefined;
        }
        return this.commands[id][0];
    }
    // convenience function
    registerNewCommand(commandId, action) {
        const command = new Command_1.default(commandId, action, this);
        return this.registerCommand(command);
    }
    // registerCommand
    registerCommand(command) {
        // TODO: ensure it is a command
        if (this.commands[command.id] === undefined) {
            this.commands[command.id] = [];
        }
        command.manager = this;
        this.commands[command.id].push(command);
        // allow chainable
        return this;
    }
    updateConnectedPeers(connectedPeers) {
        this.logger.log('Updating peer list to', connectedPeers);
        this.connectedPeers = connectedPeers;
    }
    sendRoleCommand(command, args = {}, role) {
        this.connectedPeers
            .filter((peer) => peer.role === role)
            .forEach((peer) => {
            command.sendTo(peer.public_key, args);
        });
    }
    sendAllCommand(command, args = {}) {
        this.logger.log('Sending command to', command, args, typeof command, JSON.stringify(args).length);
        if (typeof command === 'string') {
            try {
                command = this.getCommandById(command);
            }
            catch (e) {
                this.logger.warn("Couldn't find the command with id", command, 'maybe you forgot to register it?');
                this.registerNewCommand(command, () => { }); // noop
                this.sendAllCommand(command, args);
                return;
            }
        }
        if (command === undefined) {
            this.logger.warn("Couldn't find the command with id", command, 'maybe you forgot to register it?');
            return;
        }
        try {
            this.connectedPeers.forEach((peer) => command.sendTo(peer.public_key, args));
        }
        catch (e) {
            this.logger.error("Couldn't send command", command, e);
        }
    }
    // parseCommand
    handleCommand(data) {
        this.logger.log("Handling command", data);
        const commands = this.commands[data.command];
        if (commands === undefined)
            return false;
        commands.forEach((command) => { command.execute(data); });
        return true;
    }
}
const commandsManager = new CommandsManager();
// Object.freeze(commandsManager);
exports.default = commandsManager;
